module.exports = __webpack_public_path__ + "img/img27.347d97d6.jpg";